import { IAccountState } from '@mnz-modules/login/store/reducers/account.reducer';
import { IAuthState } from '@mnz-modules/login/store/reducers/auth.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const getLoginState = createFeatureSelector<{ auth: IAuthState; account: IAccountState }>('login');

export const getLoading = createSelector(getLoginState, ({ account }) => account.loading);
